module.exports = __webpack_public_path__ + "static/ace-looking-b7ad07c20d57e84c3c2161b349cbdd00.webp";